import { render, staticRenderFns } from "./ProfileContacts.vue?vue&type=template&id=c86e891c&scoped=true&"
import script from "./ProfileContacts.vue?vue&type=script&lang=js&"
export * from "./ProfileContacts.vue?vue&type=script&lang=js&"
import style0 from "./ProfileContacts.vue?vue&type=style&index=0&id=c86e891c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86e891c",
  null
  
)

export default component.exports